export const iconFontAwesomeTextformattingListUl = (
	<i className="fa-solid fa-list-ul"></i>
);
